import type { ComponentPropsOptions } from "vue";
import type { Size } from "@/components/helpers/common-props";
import { p } from "@/utils/props-builder";

export const defaultFacetedProps = {
  label: p.$string(),
  accessorKey: p.$string(),
  debounce: p.number(0),
  size: p.string<Size | "full">("sm"),
} satisfies ComponentPropsOptions;
